<template>
  <v-card>
    <v-toolbar class="teal white--text">
        <v-toolbar-title>{{ $t('configuration.basic.title') }}</v-toolbar-title>
      </v-toolbar>
    <v-card-text style="position: relative" @drop.stop="drop">
      <v-alert success transition="fade-transition" :value="saved" style="position: absolute; left: 0px; top: 0px; width: 100%; z-index: 1">
        {{ $t('configuration.basic.saved') }}
      </v-alert>

      <loadable :loading="value === null">
        <v-layout row wrap>
          <v-flex xs12>
            <v-switch
              v-model="value.insertIdent"
              :label="$t('configuration.basic.insertIdent')"
            />
          </v-flex>

          <v-flex xs12>
            <v-text-field
              v-model="value.maxAge"
              type="number"
              :label="$t('configuration.basic.maxAge')"
              :hint="$t('configuration.basic.maxAgeHint')"
            />
          </v-flex>

          <v-flex xs12>
            <v-select
              v-model="value.codecType"
              :items="compressionValues"
              :label="$t('configuration.basic.compression')"
            />
          </v-flex>

          <v-flex xs12>
            <v-select
              v-model="value.encrypt"
              :label="$t('configuration.basic.encrypt')"
              :items="encryptValues"
              item-value="value"
              item-text="text"
            />
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="isByPassword">
          <v-flex>
            <v-text-field
              v-model="value.password"
              :label="$t('configuration.basic.password')"
              type="password"
            />
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="isByKey">
          <v-flex>
            <v-text-field
              v-model="value.encryptionKey"
              :label="$t('configuration.basic.publicKey')"
              multi-line
              :rules="keyRules"
            />

            <input type="file" ref="file" @change="fileChanged" />
          </v-flex>
        </v-layout>

        <div class="text-xs-right">
          <v-btn v-if="save" class="elevation-0" success @click="save" :loading="isBusy"><v-icon dark left>save</v-icon> <span>{{ $t('save') }}</span></v-btn>
        </div>
      </loadable>
    </v-card-text>
  </v-card>
</template>

<script>
import FormContainer from '@/components/FormContainer'
import Configuration from '@/models/Configuration'

export default {
  props: ['value'],
  data () {
    return {
      isBusy: false,
      compressionValues: this.enumToOptions(Configuration.enums.compression),
      model: Configuration,
      saved: false,
      keyRules: [
        (value) => {
          if (!value) return true
          return /-----BEGIN PGP PUBLIC KEY BLOCK-----([^]*?)-----END PGP PUBLIC KEY BLOCK-----/.test(value)
            ? true
            : this.$t('configuration.basic.invalidKey')
        }
      ]
    }
  },
  computed: {
    isByPassword () {
      return this.value.encrypt === 'PASSWORD'
    },
    isByKey () {
      return this.value.encrypt === 'KEY'
    },
    encryptValues () {
      // Only allow key encryption when encryption is required
      if (this.$store.auth.user.company.requireEncryption &&
        this.$store.auth.user.company.requireEncryption
      ) {
        return this.enumToOptions({
          KEY: Configuration.enums.encrypt.KEY
        })
      }

      return this.enumToOptions(Configuration.enums.encrypt)
    }
  },
  methods: {
    enumToOptions (item) {
      return Object.keys(item).map(field => {
        return {
          text: item[field],
          value: field
        }
      })
    },
    save () {
      this.isBusy = true

      this.doSave()
        .then(saved => {
          if (this.isByKey && this.value.encryptionKey) {
            return Configuration.setKey(saved, this.value.encryptionKey)
          }
          if (this.isByPassword && this.value.password) {
            return Configuration.setPassword(saved, this.value.password)
          }
        })
        .then(() => {
          this.saved = true
          this.isBusy = false

          setTimeout(() => {
            this.saved = false
          }, 5000)
        })
        .catch(error => {
          console.error(error)

          this.isBusy = false

          if (error.response.data && error.response.data.errors) {
            if (error.response.data.errors.find(err => err.property === 'encryptionKey')) {
              alert(this.$t('configuration.basic.invalidKey'))
              return
            }
          }

          console.error(error.response)

          alert(this.$t('savingFailed'))
        })
    },
    doSave () {
      let data = { ...this.value }
      data.company = this.$store.auth.user.company

      /* if (data.encryptionKey && data.encryptionKey.length > 0) {
        data.encryptionKey = btoa(data.encryptionKey)
      } */

      if (!this.value._self) {
        return Configuration.create(data)
      } else {
        return Configuration.update(data)
      }
    },
    drop (ev) {
      let data = ev.dataTransfer
      if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].kind === 'file') {
            this.readFile(data.items[i].getAsFile())
            ev.preventDefault()
            break
          }
        }
      } else {
        this.readFile(data.files[0])
        ev.preventDefault()
      }
    },
    fileChanged () {
      if (this.$refs.file.files && this.$refs.file.files.length === 1) {
        this.readFile(this.$refs.file.files[0])
      }
    },
    readFile (file) {
      let reader = new FileReader()
      reader.onload = () => {
        this.value.encryptionKey = reader.result
      }
      reader.readAsText(file)
    }
  },
  components: {
    FormContainer
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Basic.vue?0ee83f85